import { keyframes } from '@emotion/react';
import Image from 'next/image';
import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

import PdfThumbImage from '../../../PdfThumbImage';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  margin-top: auto;
  opacity: 0;
  overflow-x: hidden;
  overflow-y: scroll;

  &.visible {
    z-index: ${VIEWER_Z_INDEX.mobileDrawer};
    animation: ${fadeIn} 0.3s ease-in-out;
    animation-fill-mode: forwards;
    animation-play-state: running;
  }

  &.hidden {
    display: none;
    animation: ${fadeOut} 0.3s ease-in-out;
    animation-fill-mode: forwards;
    animation-play-state: running;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StackPageWrapper = styled(Stack)`
  width: auto;
  height: auto;

  padding: 32px 0;

  overflow-x: scroll;
  overflow-y: scroll;
`;

export const Page = styled.li`
  display: flex;
  width: 288px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  transition: opacity 0.15s ease-in-out;

  &.current-page {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
`;

export const PageInnerWrapper = styled.div`
  position: relative;
  width: 288px;
  padding: 16px;
  border: 1px solid ${theme.colors.zinc_400} !important;
  background: ${theme.colors.white};
  border-radius: 8px;
  cursor: pointer;

  &.current-page {
    border: 1px solid ${theme.colors.skyblue_500} !important;
    background: ${theme.colors.skyblue_50};
  }

  & > span {
    position: unset !important;
    img {
      position: relative !important;
      height: auto !important;
    }
  }
`;

export const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
`;

export const BlindImage = styled(Image)`
  border: 1px solid ${theme.colors.zinc_200} !important;
  border-radius: 8px;
  &.is-blind {
    filter: blur(8px);
  }
`;

export const BlindPictureImage = styled(PdfThumbImage)`
  border: 1px solid ${theme.colors.zinc_200} !important;
  border-radius: 8px;
  &.is-blind {
    filter: blur(8px);
  }
`;

export const Dimmer = styled.div`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.mobileDrawerDimmer};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(0.5rem);
`;
